import React, { useContext, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { AppContext } from '@/AppContext';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import { useParams } from 'react-router-dom';

const PREFIX = 'MeetupSelector';

const classes = {
  root: `${PREFIX}-root`,
  color: `${PREFIX}-color`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    width: '100%',
    textAlign: 'center',
  },

  [`& .${classes.color}`]: {
    color: 'inherit',
  },
}));

const MeetupSelector = props => {
  const appContext = useContext(AppContext);
  const { mid } = useParams();

  const [meetupInfo, setMeetupInfo] = useState(null);
  useEffect(() => {
    if (mid) {
      appContext.meetupApi
        .getMeetup(mid)
        .then(({ data }) => {
          setMeetupInfo(data);
        })
        .catch(appContext.errorHandler);
    } else {
      setMeetupInfo(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mid]);

  if (mid && !meetupInfo) {
    return null;
  }

  return (
    <Root className={clsx(classes.root)}>
      <Typography variant='h4' className={clsx(classes.color)} data-test-id='top-header'>
        {mid ? meetupInfo.name : window.location.pathname.startsWith('/meetup') ? '' : ''}
      </Typography>
    </Root>
  );
};

MeetupSelector.propTypes = {
  className: PropTypes.string,
};

export default MeetupSelector;
